import React from 'react'
import { Stack, Typography } from '@mui/material'
import { AccountLinkModel } from 'src/Libs/installation-rights-management/models'
import { getDisplayName } from 'src/Libs/installation-rights-management/utils'
import LinkVariant from 'src/Elements/Buttons/LinkVariant'

interface Props {
  item?: AccountLinkModel
}
const AccountLinkNameColumn: React.VFC<Props> = ({ item }) => {
  if (item) {
    const primary = getDisplayName(item)
    const { email, userName } = item

    return (
      <Stack direction={'column'} justifyContent={'center'}>
        <Typography variant={'body2'}>{primary}</Typography>
        {(email || (item.accountType !== 'company' && userName && userName !== primary)) && (
          <LinkVariant type="email" textVariant="caption" hasUnderline={false} link={email || userName} />
        )}
      </Stack>
    )
  }

  return <span>-</span>
}

export default AccountLinkNameColumn
